<template>
  <div id="step">
    <div>
      <div class="banner">
        <img :src="bannerImg ? bannerImg : 'static/img/banner.png'" />
      </div>
    </div>
    <div class="main">
      <transition>
        <router-view></router-view>
      </transition>
      <Footer style="text-align:left;"/>
    </div>
  </div>
</template>
<script>
import api from '../api'
import utils from '../utils'
import Footer from '../components/Footer'
export default {
  name: 'Dash',
  components: {
    Footer
  },
  data() {
    return {
      bannerImg: sessionStorage.getItem('bannerImg'),

      steps: [] // 步骤图
    }
  },
  mounted() {
    if (
      sessionStorage.getItem('steps') !== '' &&
      sessionStorage.getItem('steps')
    ) {
      this.steps = JSON.parse(sessionStorage.getItem('steps'))
    }
    utils.setTitle()
    // this.loadPageConfig()
  },
  methods: {
    loadPageConfig() {
      var param = {
        ExhID: sessionStorage.getItem('ExhID'),
        RegistType: 'pc',
        page: 'AddInfo',
        Language: 'cn'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          var switchInfos = res.data.switchInfos
          for (var i = 0; i < switchInfos.length; i++) {
            if (switchInfos[i].name === 'IfSubmit') {
              //  是否提交
              this.IfSubmit = switchInfos[i].data
              sessionStorage.setItem('IfSubmit', this.IfSubmit)
            } else if (switchInfos[i].name === 'PrivacySwitch') {
              this.privacySwitch = switchInfos[i].data
            }
          }
          var promptinfo = res.data.promptinfo

          for (let i = 0; i < promptinfo.length; i++) {
            if (promptinfo[i].name === 'PrivacyInfo') {
              this.privacyInfo = promptinfo[i].value
            }
          }
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    },
    stepSwitch(stepImages) {
      switch (this.$route.path.split('/')[2]) {
        case 'personalInfo':
          return stepImages[0]

        case 'questionnaire':
          return stepImages[1]

        case 'payPage':
          return stepImages[stepImages.length - 1]
        case 'successPage':
          return stepImages[stepImages.length - 1]

        case 'noOrRefuseCheck':
          return stepImages[stepImages.length - 1]
      }
    }
  }
}
</script>
<style scoped>
#step img {
  width: 100%;
}
.main,.banner{
  width: 80%;
  margin: 0 auto;
  max-width: 1180px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dash.vue